import type { QueryClient } from "@tanstack/react-query";
import { fetchAllStudioEnrollments } from "@/features/enrollments/shared/fetchAllStudioEnrollments";
import { QueryKeys } from "@/lib/types";

const STUDIO_ENROLLMENTS_STALE_TIME_MS = 5 * 60 * 1000;

export async function prefetchStudioEnrollments(
  queryClient: QueryClient,
  accessToken: string,
) {
  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.ClassesEnrollmentsByStudentId, "studio"],
    queryFn: async () => {
      const items = await fetchAllStudioEnrollments({ accessToken });
      return { items };
    },
    staleTime: STUDIO_ENROLLMENTS_STALE_TIME_MS,
  });

  return queryClient;
}
